export const displayPreferenceUTC = 'UTC';
export const displayPreferenceUser = 'UserTimezone';
export const displayPreferenceMachine = 'MachineTimezone';

export const displayDatePreferenceValues = [
  displayPreferenceUTC,
  displayPreferenceUser,
  displayPreferenceMachine,
];
